import { useEffect, useMemo, type ReactNode } from "react";
import { useSession } from "../../../session/sessionContext";
import { csrfTokenOf } from "../../../session/sessionMachine";
import { READ_THROUGH, SourceDocumentCache } from "./sourceDocumentCache";
import { SourceDocumentContext } from "./useSourceDocument";

/** One document cache per signed-in session; signing out or in starts afresh. */
export default function SourceDocumentProvider({ children }: { children: ReactNode }) {
  const { session } = useSession();
  const sessionKey = csrfTokenOf(session);
  const cache = useMemo(() => (sessionKey === null ? null : new SourceDocumentCache()), [sessionKey]);
  useEffect(() => () => { cache?.clear(); }, [cache]);
  return <SourceDocumentContext.Provider value={cache ?? READ_THROUGH}>{children}</SourceDocumentContext.Provider>;
}
